import { render, staticRenderFns } from "./AlterarSenha.vue?vue&type=template&id=7cd1061a"
import script from "./AlterarSenha.vue?vue&type=script&lang=ts"
export * from "./AlterarSenha.vue?vue&type=script&lang=ts"
import style0 from "./AlterarSenha.vue?vue&type=style&index=0&id=7cd1061a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports